module.exports = __webpack_public_path__ + "static/media/domakoski-preta.b49a171b.jpg";